<script>

export default {
  props: ['item'],
  data() {
    return {
      dsbl_btn: false,

      loading_users: false,
      users: [],
      temp_user: {},

    }
  },
  created() {
    if(this.item.user) { this.temp_user = this.item.user; }
    this.fetch_users();
  },
  methods: {
    fetch_users() {
      this.loading_users = true;
      this.$http.get('/api/users/fetch', {params:{paginate:1000, page:1, total:0, selects:['id','email','name'], orderbys:{last_active:'desc'}}}).then(res => {
        // console.log(res);
        this.users = res.data.data;
        if(this.$route && this.$route.path.includes("/contacts") && this.$route.params.id) {
          for(var i in this.users) { if(this.users[i].id == this.item.user_id) { this.item.user = this.users[i]; } }
        }
        this.loading_users = false;
      }).catch(res => { this.loading_users = false; this.popupErrors(res); });
    },
    update_listing() {
      if(this.dsbl_btn == true) { this.$noty.warning('Disabled'); return; } this.dsbl_btn = true;

      this.$http.put('/api/listings/update', {id: this.item.id, user_id: this.temp_user.id}).then(res => {
        // console.log(res);
        if(res.data && res.data.user) {
          this.item.user_id = res.data.user.id;
          this.item.user = res.data.user;
        } else {
          this.item.user_id = null;
          this.item.user = null;
        }
        this.$noty.success("Changes have been saved");
        this.dsbl_btn = false;
      }).catch(res => { this.dsbl_btn = false; this.popupErrors(res); });
    },
  }
}
</script>

<template>
  <div>
    <div class="p-3">
      <h5 class="section-header mb-3">
      <i class="spinner-border spinner-border-sm" v-if="loading_users"></i><Icon v-else icon="ri:book-2-line"></Icon> Assigned user
    </h5>
    <p class="text-muted small mb-3">Assign to a specific user. If this user is a client they will be given access to receive invoices and upload photos. If the person you are looking for is not on this list they must first be created in the Contacts section using their email address as a reference.</p>
    <div v-if="!loading_users" class="row">
      <div class="col-sm-12 mb-2">
        <!-- <pre>{{ item.user_id }}</pre> -->
        <!-- <pre>{{ item.user }}</pre> -->
        <multiselect id="input-lead_recipients" v-model="temp_user" :options="users" :preserve-search="true" placeholder="Select..." label="name" track-by="id" required>
          <template slot="singleLabel" slot-scope="props">{{props.option.email}} <span class="text-muted">({{props.option.name}})</span></template>
          <template slot="option" slot-scope="props">{{props.option.email}} <span class="text-muted">({{props.option.name}})</span></template>
        </multiselect>
      </div>
    </div>
    </div>
    <footer class="modal-footer">
      <button type="button" class="btn btn-light" @click="$emit('hidemodel')" :disabled="dsbl_btn"><Icon icon="ri:close-fill" /> Cancel</button>
      <button type="button" class="btn btn-primary" @click="update_listing()" :disabled="dsbl_btn"><span v-if="dsbl_btn" class="spinner-border spinner-border-sm"></span><Icon v-else icon="ri:save-line" /> Save</button>
    </footer>
  </div>
</template>
